import HeroSection from './HeroSection';
import AcademicsStatsSection from './AcademicsStatsSection';
import AchievementsShowcaseSection from './AchievementsShowcaseSection';
import MathematicsSpecializationSection from './MathematicsSpecializationSection';
import CertificatesGallerySection from './CertificatesGallerySection';
import HonorsTimelineSection from './HonorsTimelineSection';

const Academics = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <HeroSection />
      <AcademicsStatsSection />
      <AchievementsShowcaseSection />
      <MathematicsSpecializationSection />
      <CertificatesGallerySection />
      <HonorsTimelineSection />
    </div>
  );
};

export default Academics;
